/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react'

import { ENTER_MSG } from '../constants/rhybus-config'
import InputLabel from './input-label'

const InputTextArea = (inputProps: any) => {
  return (
    <div className={inputProps?.formClassName}>
        {inputProps?.label && (
          <InputLabel
            className={inputProps?.inputProps?.className}
            infoLabel={inputProps?.info}
            isinfoClassName={inputProps?.infoClassName}
            isinfoIcon={inputProps?.infoIcon}
            isinfoLabel={inputProps?.isInfo}
            label={inputProps?.label}
            labelProps={{ htmlFor: inputProps?.inputProps?.id }}
            mandatory={inputProps?.isMandatory}
          />
        )}
        <textarea
          aria-label={inputProps['aria-label'] || inputProps?.label}
          aria-required={inputProps?.isMandatory}
          className={inputProps?.className}
          cols={inputProps?.cols}
          defaultValue={inputProps?.placeholder}
          disabled={inputProps?.disabled}
          id={inputProps?.inputProps?.id}
          maxLength={inputProps?.inputProps?.maxLength}
          name={inputProps?.inputProps?.name}
          onChange={inputProps?.onChange}
          placeholder={inputProps?.inputProps?.placeholder}
          readOnly={inputProps?.readonly}
          rows={inputProps?.rows}
          style={inputProps?.style}
          value={inputProps?.inputProps?.value}
        />
        {inputProps?.error && (
          <span className='errormsg'>
            {ENTER_MSG} {inputProps?.label || inputProps['aria-label']}
          </span>
        )}
      </div>
  )
}
export default InputTextArea
